module.exports = __webpack_public_path__ + "static/media/bx_mobile.d0a06e83.svg";